import React from "react"
import { CarouselComponent, CarouselComponentCanvas } from "./component"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faImages } from "@fortawesome/free-solid-svg-icons"

export default {
  id: "antd-carousel",
  block: {
    category: "Ant Design",
    icon: <FontAwesomeIcon size="3x" icon={faImages} />,
    label: "Carousel",
  },
  props: [
    {
      name: "text",
      label: "Text",
      type: "text",
      default: "text1,text2,text3",
    },
  ],
  component: CarouselComponent,
  canvas: CarouselComponentCanvas,
  components: [],
  styles: {
    position: "relative",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 10,
    paddingRight: 10,
  },
}
